// Question definitions for the SCS "Description of Studies" wizard.
//
// `number` is the stable badge shown in the CSR-style index badge (page order,
// hardcoded — it does not renumber as conditional sections toggle). `text` is
// the fallback wording; at runtime it is overridden by the wording returned
// from GET /clinical_summaries/safety_summary/questions keyed by the same key.
// `tooltip` holds ticket INFORMATION/helper text (the endpoint returns wording
// only, no tooltip map).

export const SCS_DOS_QUESTIONS = {
  qStudyClassification: {
    number: 1,
    required: true,
    text: "Classify the study type and status.",
    tooltip: "Auto-loaded from SDAP/SAP.",
  },
  qGroupingTable: {
    number: 2,
    text: "Choose the table to describe the groupings from the SAP/SDAP.",
  },
  qAdditionalGroupingTables: {
    number: 3,
    text: "Do you have any additional grouping-related tables you would like to report?",
  },
  qGroupingDefinitions: {
    number: "2A",
    text: "Define your study groupings and add the corresponding studies.",
  },
  qIndividualStudyDescriptions: {
    number: 4,
    text: "Do you want to have a description of your studies, or references only?",
  },
  qIndividualStudyList: {
    number: "4A",
    text: "List the studies you want to describe.",
  },
  qGroupingName: {
    number: 5,
    text: "Select the grouping you wish to discuss.",
    tooltip:
      "Identify the name of the column/row(s) you wish to compare/discuss.",
  },
  qDemPopulation: {
    number: 6,
    text: "What population should be used for the demographics in-text table (e.g. ITT, Full Analysis Set, etc.)?",
  },
  qComparisonType: {
    number: 7,
    text: "What comparison are you planning to make for each group?",
  },
  qNonComparativeGroupNames: {
    number: 8,
    text: "What are the actual names used to describe the treatment/analysis groups in the column headers?",
  },
  qTreatmentGroupNames: {
    number: 8,
    text: "What are the actual names used to describe the treatment/analysis groups in the column headers? Please define the role for each column name.",
  },
  qComparisonPairs: {
    number: 9,
    text: "Which dose/treatment groups should be compared?",
  },
  qDoseGroups: {
    number: 8,
    text: "Please list the dose group column headers from lowest to highest, starting with Placebo if present.",
  },
};

// Field-level (sub-label) wording for controls grouped under a numbered
// question; not badged on their own.
export const SCS_DOS_FIELD_LABELS = {
  qStudyType: "What is the type of this study?",
  qStudyStatus: "What is the status of this study?",
};
